import { get, post } from '@/utils/serviceUtil'
const envStr = window.location.href.indexOf('https://street-h5-wap.hzfangqin.com/') > -1 ? 'NODE_PRO' : 'NODE_DEV';
const Channel = envStr == 'NODE_PRO' ? "nine1" : "test"
// 详情相关接口
export const chooe = params => get('/api/enjoy/price', params, Channel)//获取支付方式以及价格
export const order = params => post('/api/enjoy/pay/androidPay', params, Channel)//下单并支付
export const getOrder = params => get('/api/enjoy/pay/query', params, Channel)//获取订单信息
export const getGoods = params => get('/api/enjoy/price', params, Channel)//获取商品信息
